import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'ras-link-block',
	templateUrl: './link-block.component.html',
	styleUrls: ['./link-block.component.sass']
})
export class LinkBlockComponent implements OnInit {

	@Input() linkText: string
	@Input() title: string
	@Input() area: string | null = null
	@Input() image: string
	@Input() alt: string
	@Input() greyed: boolean = false
	@Input() disabled: boolean = false
	@Input() tag: string | null = null
	@Input() isNewLocation: boolean = false
	@Input() link: string[]

	constructor() { }

	ngOnInit() {
	}

	track_find_location() {
		if ((<any>window).dataLayer) (<any>window).dataLayer.push({
			'event': 'select_storage_facility',
			'facility_name': this.title
		});
	}

}
